import React from 'react';

const Card = ({ title, children, className = '' }) => {
    return (
        <div className={`row ${className}`}>
            <div className="d-flex col-12">
                <div className="flex-fill w-100 card">
                    <div className="card-header">
                        <h5 className="mb-0 card-title">{title}</h5>
                    </div>
                    <div className="card-body">{children}</div>
                </div>
            </div>
        </div>
    );
};

export default Card;
